import { render } from "./CardWithImage.vue?vue&type=template&id=622b8f1d&ts=true"
import script from "./CardWithImage.vue?vue&type=script&lang=ts"
export * from "./CardWithImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__